import { FormattedDate, FormattedMessage } from 'react-intl';
import { parseLocalDate } from '../dateUtils';

interface Props {
  value: string | null;
  fallbackId?: string;
}

export default function FormattedDateOrNotSet({
  value,
  fallbackId = 'common.notSet',
}: Props) {
  if (!value) {
    return <FormattedMessage id={fallbackId} />;
  }

  return (
    <FormattedDate
      value={parseLocalDate(value)}
      year="numeric"
      month="2-digit"
      day="2-digit"
    />
  );
}
